import styled, { css } from 'styled-components';
import { renderTextVariations } from '../utils/renderTextVariations.js';
import { wrapContentWithSeparator } from '../utils/wrapContentWithSeparator.js';

const SectionHeading = styled.h2(({ type = 'default', bold, separator, stylish, theme: { olist: { components: { text: { sectionHeading }, }, }, }, }) => css `
      ${renderTextVariations(sectionHeading, type, bold, stylish)}
      ${separator && wrapContentWithSeparator()}
    `);

export { SectionHeading as default };
